// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
import type { Feel } from "@/lib/types"
import { FeelFace } from "@/components/icons"

const FEELS: Array<[Feel, string]> = [
  ["stark", "stark"],
  ["gut", "gut"],
  ["okay", "okay"],
  ["zäh", "zäh"],
  ["schmerz", "Schmerz"],
]

export default function FeelPicker({ value, onChange }: {
  value: Feel
  onChange: (feel: Feel) => void
}) {
  return (
    <div className="feels">
      {FEELS.map(([feel, label]) => (
        <button
          key={feel}
          type="button"
          data-feel={feel}
          aria-label={label}
          aria-pressed={feel === value}
          onClick={() => onChange(feel)}
        >
          <FeelFace feel={feel} size={26} />
        </button>
      ))}
    </div>
  )
}
